import { default as domainHourGroup } from './group/store'
import { default as domainHour } from './hour/store'
import { default as domainScheduleByDate } from './schedule-by-date/store'
import { default as domainSchedule } from './schedule/store'

export default { 
	domainHourGroup,
	domainHour,
	domainScheduleByDate,
	domainSchedule
}
